import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import CloseModal from "../../components/Atomos/Icons/EditMode/CloseModal";
import { memberModalSecondaryButtonClassName } from "../../components/Moleculas/Profile/memberModalFooterButtonClasses";

export interface ProfileListMoreModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  titleId?: string;
  children: React.ReactNode;
}

const ProfileListMoreModal: React.FC<ProfileListMoreModalProps> = ({
  isOpen,
  onClose,
  title,
  titleId = "profile-list-more-title",
  children,
}) => {
  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        onClose();
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [isOpen, onClose]);

  if (!isOpen) {
    return null;
  }

  return createPortal(
    <div
      className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/60 p-4"
      onClick={onClose}
      role="presentation"
    >
      <div
        className="flex max-h-[90vh] w-full max-w-lg flex-col overflow-hidden rounded-none bg-white shadow-xl"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
      >
        <div className="flex shrink-0 items-start justify-between gap-4 border-b border-gray-100 px-6 py-5 md:px-8">
          <h2 id={titleId} className="font-decimal text-xl font-semibold text-primary md:text-2xl">
            {title}
          </h2>
          <button
            type="button"
            className="flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center text-gray-font hover:text-gray-600"
            onClick={onClose}
            aria-label="Close"
          >
            <CloseModal />
          </button>
        </div>

        <div className="min-h-0 flex-1 overflow-y-auto px-6 py-4 md:px-8 md:py-5">{children}</div>

        <div className="flex shrink-0 justify-end border-t border-gray-100 px-6 py-4 md:px-8">
          <button type="button" className={memberModalSecondaryButtonClassName} onClick={onClose}>
            <span>Close</span>
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ProfileListMoreModal;
